module.exports = __webpack_public_path__ + "img/Health_Record.b2720e35.svg";